import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  VERIFY_EMAIL_ACCOUNT,
  VERIFY_EMAIL_ACCOUNT_SUCCESS,
  VERIFY_EMAIL_ACCOUNT_ERROR,
  POST_RESET_USER_SUCCESS,
  POST_RESET_USER_FAIL,
  POST_RESET_USER,
  POST_CHANGE_PASSWORD,
  POST_CHANGE_PASSWORD_SUCCESS,
  POST_CHANGE_PASSWORD_FAIL,
} from "./actionTypes"

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  resetSuccessMsg: null,
  resetError: null,
  compresetError: null,
  compresetSuccessMsg: null,
  compresetError: null,
  changepwdSuccessMsg: null,
  changepwdError: null,
}

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
      }
      break
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
      }
      break
    case FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload }
      break
    case RESET_PASSWORD:
      state = {
        ...state,
        resetSuccessMsg: null,
        resetError: null,
      }
      break
    case RESET_PASSWORD_SUCCESS:
      state = {
        ...state,
        resetSuccessMsg: action.payload,
      }
      break
    case RESET_PASSWORD_ERROR:
      state = { ...state, resetError: action.payload }
      break
    case VERIFY_EMAIL_ACCOUNT:
      state = {
        ...state,
        verifyEmailSuccessMsg: null,
        verifyEmailErrorMsg: null,
        loading: false,
      }
      break
    case VERIFY_EMAIL_ACCOUNT_SUCCESS:
      state = {
        ...state,
        verifySuccessMsg: action.payload,
        loading: true,
      }
      break
    case VERIFY_EMAIL_ACCOUNT_ERROR:
      state = { ...state, verifyErrorMsg: action.payload, loading: false }
      break

    //reset Password
    case POST_RESET_USER:
      state = {
        ...state,
        compresetSuccessMsg: null,
        compresetError: null,
      }
      break
    case POST_RESET_USER_SUCCESS:
      state = {
        ...state,
        compresetSuccessMsg: action.payload,
      }
      break
    case POST_RESET_USER_FAIL:
      state = { ...state, compresetError: action.payload }
      break

      //change Password
    case POST_CHANGE_PASSWORD:
      state = {
        ...state,
        changepwdSuccessMsg: null,
        changepwdError: null,
      }
      break
    case POST_CHANGE_PASSWORD_SUCCESS:
      state = {
        ...state,
        changepwdSuccessMsg: action.payload,
      }
      break
    case POST_CHANGE_PASSWORD_FAIL:
      state = { ...state, changepwdError: action.payload }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default forgetPassword
